import React, { useEffect, useState } from 'react';
import { Divider, Typography, Box } from '@mui/material';
import { ArrowOutward } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { updateResourceSummary } from '../../redux-store/currentUserActions';
import ApiKeyAuthorization from './ApiKeyAuthorization';
import BearerTokenAuthorization from './BearerTokenAuthorization';
import BasicAuthorization from './BasicAuthorization';
import AWSAuthorization from './AWSAuthorization';

const AuthorizationComponent = ({
  allowInheritFromParent, authorization, onAuthorizationUpdate,
}) => {
  const authTypes = [
    'No Auth',
    'Bearer Token',
    'Api Key',
    'Basic Auth',
    'Token Auth',
    // 'Aws Signature',
  ];
  if (allowInheritFromParent) {
    authTypes.unshift('Inherit auth from parent');
  }
  const [selectedType, setSelectedType] = useState('No Auth');

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  const toSnakeCase = (str) => {
    return str
      .replace(/\s+/g, '_')
      .replace(/([A-Z])/g, (match, letter) => `${letter.toLowerCase()}`)
      .toLowerCase();
  };

  const toNormalCase = (str) => {
    return str
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (match) => match.toUpperCase());
  };

  useEffect(() => {
    if (authorization?.authorization_type) {
      setSelectedType(toNormalCase(authorization?.authorization_type));
    } else {
      setSelectedType('No Auth');
    }
  }, [authorization]);

  const handleApiCall = async ({ authorization_value }) => {
    authorization_value ||= {};
    onAuthorizationUpdate({
      authorization_type: toSnakeCase(selectedType),
      authorization_value: authorization_value
    })
  };

  return (
    <Box style={{ width: '100%', overflowX: 'hidden' }}>
      <Typography
        style={{
          fontSize: '11px', fontWeight: '400', color: 'var(--text-primary)',
        }}
      >
        This authorization method will be used for every request in this
        collection. You can override this by specifying one in the request.
      </Typography>
      <Box
        style={{
          marginTop: '25px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{
          marginRight: '10px',
          color: 'var(--text-primary)',
        }}>Type</div>
        <select
          className="form-select"
          id="authType"
          name="authType"
          value={selectedType}
          onChange={handleTypeChange}
          onBlur={handleApiCall}
          style={{
            width: '200px',
            backgroundColor: 'var(--background-primary)',
            color: 'var(--text-primary)',
            border: '1px solid var(--borderColor)',
          }}
        >
          {authTypes.map((auth) => (
            <option key={auth} value={auth}>
              {auth}
            </option>
          ))}
        </select>
      </Box>
      {selectedType === 'No Auth' && (
        <>
          <Divider sx={{ borderBottom: 'outset', marginTop: '2%' }} />
          <div>
            <p
              style={{
                marginTop: '10px',
                textAlign: 'center',
                color: 'var(--text-primary)',
              }}
            >
              This collection does not use any authorization. Learn more about
              <a>
                {' '}
                <u> authorization</u>
              </a>
              <ArrowOutward style={{ fontSize: '16px' }}></ArrowOutward>
            </p>
          </div>
        </>
      )}
      {selectedType === 'Api Key' && (
        <ApiKeyAuthorization
          authorization={authorization?.authorization_value}
          onAuthorizationUpdate={handleApiCall}
        />
      )}
      {selectedType === 'Bearer Token' && (
        <BearerTokenAuthorization
          authorization={authorization?.authorization_value}
          onAuthorizationUpdate={handleApiCall}
        ></BearerTokenAuthorization>
      )}
      {selectedType === 'Basic Auth' && (
        <BasicAuthorization
          authorization={authorization?.authorization_value}
          onAuthorizationUpdate={handleApiCall}
        ></BasicAuthorization>
      )}
      {selectedType === 'Token Auth' && (
        <BearerTokenAuthorization
          authorization={authorization?.authorization_value}
          onAuthorizationUpdate={handleApiCall}
        ></BearerTokenAuthorization>
      )}
      {/* {selectedType === 'Aws Signature' && (
        <AWSAuthorization
          authorization={authorization?.authorization_value}
          onAuthorizationUpdate={handleApiCall}
        ></AWSAuthorization>
      )} */}
    </Box>
  );
};

export default AuthorizationComponent;
